import React from "react";
import CertifiedBadge from "../../shared/CertifiedBadge";
import ContentCard, { ContentCardProps } from "../../shared/ContentCard";

interface CertifiedTabProps {}

const CertifiedTab: React.FC<CertifiedTabProps> = (props) => {
  const headding = "Menu is certified by foodpromise";
  const certifiedItems: Array<ContentCardProps> = [
    {
      imgElement: <CertifiedBadge type="circle" />,
      title: "Checkpoint 1",
      text: "Gewicht Salat: 356g",
    },
    {
      imgElement: <CertifiedBadge type="circle" />,
      title: "Checkpoint 2",
      text: "Arrange",
      actionElement: (
        <div className="gallery-icon">
          <img
            src="/images/gallery_icon.svg"
            alt="gallery icon"
            width={24}
            height={16}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      <div className="title-with-badge">
        <h2>{headding}</h2>
        <CertifiedBadge label="certified" type="horizontal" />
      </div>
      <div className="content-card-wrap">
        {certifiedItems.map((data, index) => (
          <ContentCard
            key={index}
            title={data.title}
            text={data.text}
            isLinkCard={true}
            imgElement={data.imgElement}
            actionElement={data?.actionElement}
          />
        ))}
      </div>
    </>
  );
};

export default CertifiedTab;
